export const resumeConfig = {
  label: "Resume",
  url: "https://drive.google.com/file/d/1cEgnDoSJCLupfsAsm7OYp6iYeTOZ_hxn/view?usp=sharing",
  isExternal: true,
};
